import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage23.module.css";

export default function LaymanPage23() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>FORCES OF THE MOON</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_new_moon_block_main}>
                <div
                  className={`${styles.new_moon_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.new_moon_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block1_img.webp"
                    /> */}
                    <img className={styles.new_moon_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block1_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>The Lunar Mysteries:</b> Unveiling the Forces of the
                        Moon in <Link href="https://www.divineinfinitebeing.com/">the School of Divine Infinite Being</Link> method and
                        Archetypal Astrology
                      </p>

                      <p>
                        In the intricate world of occult forces, the Moon
                        emerges as a captivating celestial entity within the
                        realms of the School method and Archetypal Astrology.
                        Serving as a vessel for potent planetary forces, the
                        Moon holds a profound relationship with the Unconscious,
                        guiding seekers through the depths of Psi
                        power experiences.
                      </p>

                      <p>
                        At the heart of the lunar energies lies a complex
                        tapestry of the Unconscious Realms, ranging from the
                        higher unconscious, symbolizing our evolving selves, to
                        the lower unconscious, the mysterious Underworld of the
                        shades, and the middle unconscious, known as the{" "}
                        <span><i>"Archetypal Cosmological Ingression."</i></span>
                      </p>

                      <p>
                        Activation of the forces of the Moon requires
                        introspection and deep reflection. As we delve into the
                        recesses of our consciousness, we become attuned to the
                        greater awareness within us, expanding our access
                        through the intuitive currents that flow like the gentle
                        light of the Moon. This receptivity is the key to
                        unlocking the Lunar energies, intimately connected to
                        the Soul and its poetic essence that dances in the
                        forests of Pan, playing sweet songs for the Nymphs who
                        beckon us into the enchanting realms of nature.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.new_moon_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block2_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        The Moon, with its pure feminine principles, grants
                        access to a myriad of psychic phenomena, including
                        pre-cognition, remote viewing, mediumship, and
                        divination. It frames the Astral Light, an Imaginal
                        Realm of the Soul, illuminating the deepest personal
                        narratives that shape our existence. During every full
                        moon, practitioners draw down the Moon, bathing in its
                        intuitive light to cleanse and rejuvenate consciousness.
                      </p>

                      <p>
                        In its Archetypal instinct, the Moon is the{" "}
                        <span><i>"Reflection of Self,"</i></span> serving as a mirror
                        that unveils the inner depths of our being. This
                        archetypal force propels us towards{" "}
                        <span><i>"Intuitive Empowerment,"</i></span> encouraging us to
                        harness the profound wisdom embedded in the lunar
                        energies.
                      </p>

                      <p>
                        The forces of the Moon, with their ethereal allure, call
                        upon seekers to explore the mystical dimensions of the
                        Unconscious. Through deep reflection and intuitive
                        receptivity, individuals can tap into the transformative
                        powers of the Moon, navigating the astral landscapes of
                        the psyche and embracing the poetic essence of the Soul.
                        In the dance between light and shadow, the Moon reveals
                        itself as a celestial guide, inviting us to unlock the
                        secrets of our inner world and empower ourselves through
                        the intuitive currents that bathe us in its luminous
                        glow.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.new_moon_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.new_moon_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block3_img.webp"
                    /> */}
                     <img className={styles.new_moon_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block3_img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.yellow_box_heading}>
                        <h1>Astrological Features:</h1>
                      </div>

                      <p>
                        <b>Occult Forces:</b> The Moon is a significant Occult
                        force within <Link href="https://www.divineinfinitebeing.com/">The School of Divine Infinite Being</Link> method and
                        Archetypal Astrology, symbolizing potent planetary
                        energies.
                      </p>

                      <p>
                        <b>Unconscious Realms:</b> Lunar energies encompass
                        various Unconscious Realms, including the higher
                        unconscious, the evolving aspect of self, the lower
                        unconscious representing the Underworld of the shades,
                        and the middle unconscious known as{" "}
                        <span><i>"Archetypal Cosmological Ingression."</i></span>
                      </p>

                      <p>
                        <b>Activation through Introspection:</b> Forces of the
                        Moon are activated through introspection and deep
                        reflection, urging individuals to explore the recesses
                        of their consciousness.
                      </p>

                      <p>
                        <b>Access to Greater Consciousness:</b> Deep reflection
                        allows individuals to become aware of the greater
                        consciousness within, expanding access through
                        intuition, akin to the receptive light of the Moon.
                      </p>

                      <p>
                        <b>Feminine Principles:</b> The Moon, with its pure
                        feminine principles, grants access to pre-cognition,
                        remote viewing, mediumship, and divination.
                      </p>

                      <p>
                        <b>Connection to the Soul:</b> Lunar energies are
                        closely related to the Soul, particularly its poetic
                        side, drawing individuals into the forests of Pan and
                        enticing them with sweet songs for the Nymphs of nature.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.new_moon_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block4_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_the_moon/the_moon_block4_img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Psychic Phenomena:</b> The Moon facilitates psychic
                        phenomena such as pre-cognition, allowing glimpses into
                        the future, and remote viewing, transcending physical
                        boundaries to perceive distant places.
                      </p>

                      <p>
                        <b>Mediumship:</b> Lunar energies support mediumship,
                        enabling communication with spiritual entities and
                        entities from the Underworld.
                      </p>

                      <p>
                        <b>Divination:</b> The Moon's forces are associated with
                        divination, providing insights into the unseen realms
                        and guiding individuals through the interpretation of
                        symbols and signs.
                      </p>

                      <p>
                        <b>Astral Light:</b> The Moon frames the Astral Light,
                        an Imaginal Realm of the Soul, illuminating deep
                        personal narratives and enhancing spiritual experiences.
                      </p>

                      <p>
                        <b>Full Moon Practices:</b> Practitioners draw down the
                        Moon's energy during full moons, engaging in rituals to
                        harness its intuitive light for cleansing and
                        rejuvenating consciousness.
                      </p>

                      <p>
                        <b>Archetypal Instinct:</b> The Moon serves as an
                        Archetypal instinct, reflecting the self and inspiring{" "}
                        <span><i>"Intuitive Empowerment"</i></span> as individuals
                        align with its transformative energies.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>
                          The Astrological Tarot association for the Moon is{" "}
                          <br />
                          The High Priestess. See our alchemical ROTA here.
                        </h1>
                      </div>
                    </Link>
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/layman_page23_block1_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/layman_page23_block2_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/layman_page23_block3_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/layman_page23_block4_demo_img_nw_ds.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_the_moon/layman_page23_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
